import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import "./style.scss";
import { FiX } from "react-icons/fi";
import UserService from "../../../../services/user.service";
import useCustomToast from "../../../../hooks/useCustomToast";
import { Toaster } from 'react-hot-toast'

type Anchor = "right";

export default function AddInstructorModal({
  toggleDrawer,
  state,
  inputs,
  handleInput,
  sendInvitation
}: {
  toggleDrawer: any,
  state: any,
  inputs: any,
  handleInput: any,
  sendInvitation: any
}) {
  const list = (anchor: Anchor) => (
    <Box sx={{ width: 517, padding: 3 }} role="presentation">
      <div className="d-flex justify-content-between">
        <h2 className="heading2">Add New Student</h2>
        <span role="button" onClick={toggleDrawer("right", false)}>
          <FiX style={{ fontSize: 20 }} />
        </span>
      </div>
      <form action="" className="add_user_form">
        <h4 className="title">DETAILS</h4>
        <div className="input_group">
          <label htmlFor="">Student Name#</label>
          <input type="text" placeholder="Enter Name Here" name="name" defaultValue={inputs.name} onChange={handleInput} />
        </div>
        <div className="input_group">
          <label htmlFor="">Expiration</label>
          <input type="date" name="expiration" defaultValue={inputs.expiration} onChange={handleInput} />
        </div>

        <div className="input_group">
          <label htmlFor="">Student Email</label>
          <input type="email" name="toEmail" placeholder="Enter Your Email" defaultValue={inputs.toEmail} onChange={handleInput} />
        </div>

        <button className="button" onClick={sendInvitation}>Add Student</button>
      </form>
    </Box>
  );

  return (
    <div>
      <React.Fragment>
        <Drawer
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
        >
          {list("right")}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
